import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import {
    AttachmentDocContainer,
    AssetErrorNotFound,
    UnreadReplies,
} from 'owa-timestream-asset-sdk';
import MessageItem from './MessageItem';
import type Message from 'owa-service/src/contract/Message';
import type AttachmentPreview from 'owa-service/src/contract/AttachmentPreview';
import type { UnreadRepliesProps } from '../schema';
import RepliesContainer from './RepliesContainer';

export default observer(function MailItemView({
    attachmentPreviews,
    item,
    notFound,
    openReadingPane,
    unreadRepliesProps,
    DueDate,
}: {
    attachmentPreviews: AttachmentPreview[];
    item: Message;
    notFound: boolean;
    openReadingPane: () => void;
    unreadRepliesProps: UnreadRepliesProps;
    DueDate?: React.ReactNode;
}) {
    const mainMessageStyle = {
        body: styles.mailItemView,
        preview: styles.preview,
        unread: styles.unread,
        timeAndPersonaWrapper: styles.timeAndPersonaWrapper,
    };
    const { unreadReplies, unreadRepliesCount } = unreadRepliesProps;
    const repliesContainer = unreadReplies && unreadReplies.length > 0 && (
        <RepliesContainer unreadReplies={unreadReplies} />
    );

    return (
        <div className={styles.mailAsset}>
            <div className={styles.mailItemView}>
                <div>{DueDate}</div>
                <MessageItem
                    message={item}
                    messageItemStyle={mainMessageStyle}
                    onMessageClicked={openReadingPane}
                    showSubject={true}
                />
                {repliesContainer && (
                    <UnreadReplies
                        unreadRepliesCount={unreadRepliesCount}
                        unreadReplies={repliesContainer}
                        assetType={'mailItem'}
                    />
                )}
                {attachmentPreviews.length > 0 && (
                    <AttachmentDocContainer
                        itemId={item.ItemId!.Id}
                        attachments={attachmentPreviews}
                        maxResults={2}
                    />
                )}
                {notFound && <AssetErrorNotFound />}
            </div>
        </div>
    );
});
